import React, { useState, useEffect, Dispatch, SetStateAction, ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import ticketFree from 'assets/img/icons/ticket_free.svg';
import ticketImg from 'assets/img/icons/ticket.svg';
import { ElementsConsumer } from '@stripe/react-stripe-js';
import i18next from 'i18next';
import { Stripe } from '@stripe/stripe-js/types/stripe-js';
import { StripeElements } from '@stripe/stripe-js';
import { useSnackbar } from 'notistack';
import logob from '../../../../assets/img/gotmy-n.png';
import Checkout from '../Checkout';
import useUserOrLocalTimeHour from '../../../../config/hooks/useUserOrLocalTimeHour';
import useBuyEvent from '../../../../config/hooks/useBuyEvent';
import { parsePriceByCurrencyJustSymbol, parsePriceByCurrency } from '../../../../config/utils/currencyUtils';
import { Currency } from '../../../../models/Currency';
import EventName from '../EventName';
import EventDateLarge from '../EventDateLarge';
import { EventData } from '../../../../models/EventData';
import UserScore from '../UserScore';

interface ModalProps extends Props {
    stripe: Stripe | null;
    elements: StripeElements | null;
}

const ModalBuyEvent = ({
    currency,
    confirmEmail,
    setConfirmEmail,
    email,
    setEmail,
    stripe,
    elements,
    mobileNav,
    modalDetail,
    setModalDetail,
    eventData,
    onGetUser,
    setModalPurchaseSuccess,
}: ModalProps) => {
    const { enqueueSnackbar } = useSnackbar();
    const [finalPrice, setFinalPrice] = useState<string>();
    const [totalFee, setTotalFee] = useState<string>();
    const [savedCard, setSavedCard] = useState<{ status: boolean; stripe_payment_method_id?: number }>({
        status: false,
    });
    const [redirect, setRedirect] = useState<{ status?: boolean | undefined; url?: string }>({
        status: false,
        url: '',
    });
    const [privacy, setPrivacy] = useState<boolean>(false);
    const [usesPaypal, setUsesPaypal] = useState<boolean>(false);
    const [terms, setTerms] = useState<boolean>(false);

    const {
        event_title,
        event_date,
        event_uuid,
        event_cover_image,
        event_price_ticket,
        event_price_ticket_streaming,
        ticket,
        ticket_streaming,
    } = eventData.event;

    const { user_username, user_avatar } = eventData.user;
    const { payment, handlePurchase } = useBuyEvent({
        savedCard,
        ticket,
        finalPrice,
        setRedirect,
        usesPaypal,
        redirect,
        stripe,
        elements,
        onGetUser,
        privacy,
        terms,
        email,
        confirmEmail,
        event_uuid,
    });

    const { time } = useUserOrLocalTimeHour(event_date, eventData.event);

    useEffect(() => {
        if (payment.status === 'success') {
            setModalDetail(false);
            setModalPurchaseSuccess(true);
        }
        if (payment.status === 'error') {
            enqueueSnackbar(payment.message || 'Unknown error', { variant: 'error' });
        }
    }, [payment, enqueueSnackbar, setModalDetail, setModalPurchaseSuccess]);

    useEffect(() => {
        let finalPrice;
        let fee;
        if (event_price_ticket !== null) {
            if (event_price_ticket === 0) {
                setFinalPrice('0');
                setTotalFee('0');
            } else if (event_price_ticket > 0 && ticket) {
                fee = ticket.gotmy_min_ticket_fee + ticket.gotmy_ticket_fee * 0.01 * event_price_ticket;
                finalPrice = event_price_ticket + fee;
                setTotalFee(fee.toFixed(2));
                setFinalPrice(finalPrice.toFixed(2));
            }
        } else if (event_price_ticket_streaming !== null) {
            if (event_price_ticket_streaming === 0) {
                setFinalPrice('0');
                setTotalFee('0');
            } else if (event_price_ticket_streaming > 0 && ticket_streaming) {
                fee =
                    ticket_streaming.gotmy_min_ticket_fee +
                    ticket_streaming.gotmy_ticket_fee * 0.01 * event_price_ticket_streaming;
                finalPrice = event_price_ticket_streaming + fee;
                setTotalFee(fee.toFixed(2));
                setFinalPrice(finalPrice.toFixed(2));
            }
        }
    }, [event_price_ticket, event_price_ticket_streaming, ticket, ticket_streaming]);

    return (
        <Modal show={modalDetail} onHide={() => setModalDetail(false)}>
            {mobileNav && (
                <Modal.Header closeButton>
                    <div className="text-center   w-100">
                        <span className="">{i18next.t('ModalBuyEventComponentBuyTicket')}</span>
                    </div>
                </Modal.Header>
            )}
            <Modal.Body>
                {!redirect.status ? (
                    <>
                        {!mobileNav && <img src={logob} className="mw-100 Logo" alt="logo" />}
                        <div className="d-flex flex-column flex-md-row">
                            <div className={`${!mobileNav && 'Div-g'}`}>
                                {!mobileNav && (
                                    <img
                                        style={{ height: '280px', width: '100%', objectFit: 'cover' }}
                                        className="mw-100 mt-4 br-10 mb-4"
                                        src={event_cover_image}
                                        alt=""
                                    />
                                )}
                                {!mobileNav && (
                                    <UserScore userName={user_username} userAvatar={user_avatar} />
                                )}
                                <div
                                    className={`d-flex mb-4 mb-md-0 mt-2 ${
                                        !mobileNav ? 'align-items-center' : 'align-items-start'
                                    }`}
                                >
                                    {time && <EventDateLarge day={time.day} month={time.month} />}
                                    {time && <EventName upcoming title={event_title} hour={time.time} />}
                                </div>
                            </div>
                            <div className={`${!mobileNav && 'Div-m'} d-flex flex-column`}>
                                {!mobileNav && (
                                    <p className="Ticket">
                                        {' '}
                                        {i18next.t('ModalBuyEventComponentEventTicket')}{' '}
                                        {parsePriceByCurrency(finalPrice, currency)}
                                    </p>
                                )}
                                <div className="d-flex align-items-center mb-3">
                                    <img src={ticketImg} alt="ticket" className="eventPriceImg" />
                                    <div className="d-flex flex-column ml-3 w-100">
                                        <span
                                            style={{
                                                fontWeight: 600,
                                                color: 'black',
                                            }}
                                        >
                                            {i18next.t('ModalBuyEventComponentEventPrice')}
                                        </span>
                                        {event_price_ticket > 0 || event_price_ticket_streaming > 0 ? (
                                            <span className="Input-linea">
                                                {' '}
                                                {event_price_ticket !== null
                                                    ? parsePriceByCurrencyJustSymbol(
                                                          event_price_ticket.toString(),
                                                          currency,
                                                      )
                                                    : parsePriceByCurrencyJustSymbol(
                                                          event_price_ticket_streaming,
                                                          currency,
                                                      )}
                                            </span>
                                        ) : (
                                            <span className="Input-linea">
                                                {i18next.t('ModalBuyEventComponentFree')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex align-items-center mb-3">
                                    <img src={ticketFree} alt="free ticket" className="eventPriceImg" />
                                    <div className="d-flex flex-column ml-3 w-100">
                                        <span style={{ fontWeight: 600, color: 'black' }}>
                                            {i18next.t('ModalBuyEventComponentGotMyFees')}
                                        </span>
                                        {ticket ? (
                                            <span className="Input-linea">
                                                {' '}
                                                {parsePriceByCurrencyJustSymbol(
                                                    ticket.gotmy_min_ticket_fee.toString(),
                                                    currency,
                                                )}{' '}
                                                + {ticket.gotmy_ticket_fee}% ={' '}
                                                {parsePriceByCurrencyJustSymbol(totalFee, currency)}{' '}
                                            </span>
                                        ) : (
                                            <span className="Input-linea">
                                                {' '}
                                                {parsePriceByCurrencyJustSymbol(
                                                    ticket_streaming.gotmy_min_ticket_fee,
                                                    currency,
                                                )}{' '}
                                                + {ticket_streaming.gotmy_ticket_fee}% ={' '}
                                                {parsePriceByCurrencyJustSymbol(totalFee, currency)}{' '}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                {parseFloat(finalPrice || '0') > 0 && (
                                    <p className="Title">
                                        {i18next.t('ModalBuyEventComponentPaymentMethod')}
                                    </p>
                                )}
                                <Checkout
                                    savedCard={savedCard}
                                    setSavedCard={setSavedCard}
                                    currency={currency}
                                    setUsesPaypal={setUsesPaypal}
                                    paypal={usesPaypal}
                                    handlePurchase={handlePurchase}
                                    email={email}
                                    setEmail={setEmail}
                                    confirmEmail={confirmEmail}
                                    setConfirmEmail={setConfirmEmail}
                                    payment={payment}
                                    privacy={privacy}
                                    setPrivacy={setPrivacy}
                                    terms={terms}
                                    setTerms={setTerms}
                                    finalPrice={finalPrice}
                                />
                            </div>
                        </div>
                    </>
                ) : (
                    <iframe
                        id="iframe"
                        title="redirect"
                        src={redirect.url}
                        width="100%"
                        height="700"
                        frameBorder="0"
                        marginHeight={0}
                        marginWidth={0}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
};

interface Props {
    currency: Currency;
    confirmEmail: string;
    setConfirmEmail: Dispatch<SetStateAction<string>>;
    email: string;
    setEmail: Dispatch<SetStateAction<string>>;
    mobileNav: boolean;
    modalDetail: boolean;
    setModalDetail: Dispatch<SetStateAction<boolean>>;
    eventData: EventData;
    onGetUser: () => void;
    setModalPurchaseSuccess: Dispatch<SetStateAction<boolean>>;
}

const InjectedCheckoutForm = ({
    currency,
    confirmEmail,
    setConfirmEmail,
    email,
    setEmail,
    mobileNav,
    modalDetail,
    setModalDetail,
    eventData,
    onGetUser,
    setModalPurchaseSuccess,
}: Props): ReactElement => {
    return (
        <ElementsConsumer>
            {({ stripe, elements }) => (
                <ModalBuyEvent
                    currency={currency}
                    confirmEmail={confirmEmail}
                    setConfirmEmail={setConfirmEmail}
                    email={email}
                    setEmail={setEmail}
                    stripe={stripe}
                    elements={elements}
                    mobileNav={mobileNav}
                    modalDetail={modalDetail}
                    setModalDetail={setModalDetail}
                    onGetUser={onGetUser}
                    setModalPurchaseSuccess={setModalPurchaseSuccess}
                    eventData={eventData}
                />
            )}
        </ElementsConsumer>
    );
};

export default InjectedCheckoutForm;
